import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import DelegacionesProfecoTable from './_DelegacionesProfecoTable.js';
import EditDelegacionProfeco from './_EditDelegacionProfeco.js';
const URI = ApiEndpoint + 'administration/';
const DelegacionesProfeco = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [delegacionesProfeco, setDelegacionesProfeco] = useState(false);
  const [idDelegacionProfecoEdit, setIdDelegacionProfecoEdit] = useState(false);
  const handleClose = () => {
    setOpenModal(false);
    getDelegacionesProfeco();
  };
  const getDelegacionesProfeco = async () => {
    console.log('entre a getClasificacionesQueja');
    setDelegacionesProfeco(null);

    httpClient('GET', URI + 'delegations/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setDelegacionesProfeco(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    getDelegacionesProfeco();
  }, []);
  return (
    <>
      {delegacionesProfeco && (
        <DelegacionesProfecoTable
          delegacionesProfeco={delegacionesProfeco}
          setIdDelegacionProfecoEdit={setIdDelegacionProfecoEdit}
          setOpenModal={setOpenModal}
        ></DelegacionesProfecoTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idDelegacionProfecoEdit > 0 ? 'Editar' : 'Agregar') +
            ' Delegacion Profeco'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditDelegacionProfeco
            closeModal={handleClose}
            idDelegacionProfeco={idDelegacionProfecoEdit}
          ></EditDelegacionProfeco>
        </MyModal>
      )}
    </>
  );
};

export default DelegacionesProfeco;
